// plugins/initAuth.ts
import { useAuthStore } from '@/stores/authStore';
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  const authStore = useAuthStore();
  authStore.loadToken();
});
